<section class="py-4 flex justify-between align-middle">
  <div>
    <h1 class="text-4xl font-bold">{{ title() }}</h1>
  </div>
  <div>

    @if (actionLabel() != '') {

      <button (click)="executeAction()" class="flex gap-2 items-center py-2 px-4 bg-secondary hover:bg-secondary-hover text-white rounded-md duration-300 transition-all">
        {{ actionLabel() }}
        <lucide-icon [name]="PlusCircle" size="20"></lucide-icon>
      </button>

    }

  </div>
</section>
